<template>
	<div class="loginTemplate">

		<el-dialog title="提示" :visible.sync="loginVisible" :close-on-click-modal="false" :close-on-press-escape="false" width="1064px">
			<div class="loginResetRegClose pointer" @click="loginVisible=false">
				<!--<i class="el-icon-circle-close"></i>-->
				<img class="iconClosed" v-if="!isSearch" src="//frontend.originoo.com/originoo_web/login/iconclose.png" />
			</div>
			<!--登录修改密码-->
			<section class="loginReset flex" v-if="loginType=='login'||loginType=='reset'">
				<div class="loginReset_left flex_item flex_left">
					<img src="//frontend.originoo.com/originoo_web/login/loginresetpic.png" alt="">
				</div>
				<div class="loginReset_right flex_item flex_right">
					<div class="loginReset_login loginReset_rItem" v-if="loginType=='login'">
						<div class="title_loginReg">
							<div class="title_loginReg_item active pointer">登录</div>
							<div class="title_loginReg_item pointer" @click="loginTemplate('reg',isSearch)">注册</div>
						</div>
						<div class="login_title">欢迎登录</div>
						<a id="clickGOQY" href="https://vip.originoo.com" target="_blank" style="display:none;">企业</a>
						<div class="login_personalCompany">
							<div class="login_personal pointer">个人</div>
							<div class="login_company pointer" @click="toGOQY"><a href="https://vip.originoo.com" target="_blank">企业</a></div>
						</div>

						<div class="login_inp" @keyup.enter="loginAccount">
							<el-input v-model="login_phone" placeholder="请输入手机号/邮箱"></el-input>
							<el-input v-model="login_password" placeholder="请输入密码" type="password"></el-input>
						</div>
						<div class="rememberForget">
							<el-checkbox v-model="isAutoLogin">自动登录</el-checkbox>
							<el-button type="text" @click="loginTemplate('reset',isSearch)">忘记密码？</el-button>
						</div>
						<div class="thirdLogin">
							<div class="thirdLogin_title">第三方登录</div>
							<div class="third_imgBox">
								<!--<a class="qq_login" href="https://graph.qq.com/oauth2.0/authorize?response_type=code&amp;client_id=101397228&amp;redirect_uri=https://www.originoo.com/login_third&amp;state=qq"></a>
								<a class="wx_login" href="https://open.weixin.qq.com/connect/qrconnect?appid=wxf98738f2093585ec&amp;redirect_uri=https://www.originoo.com/login_third&amp;response_type=code&amp;scope=snsapi_login&amp;state=weixin#wechat_redirect"></a>
								-->
								<a class="qq_login" href="https://graph.qq.com/oauth2.0/show?which=Login&amp;display=pc&amp;response_type=code&amp;client_id=101397228&amp;redirect_uri=https://www.originoo.com/login_third&amp;state=qq"></a>
								<a class="wx_login" href="https://open.weixin.qq.com/connect/qrconnect?appid=wxf98738f2093585ec&amp;redirect_uri=https://www.originoo.com/login_third_wechat&amp;response_type=code&amp;scope=snsapi_login&amp;state=weixin#wechat_redirect"></a>


								<!--<div class="qq_login" @click="qqLogin"></div>
								<div class="wx_login" @click="wxLogin"></div>-->
								<!--<div class="sina_login"></div>-->
							</div>
						</div>

						<div class="loginBtn pointer" @click="loginAccount">
							立即登录
						</div>
						<div class="noReg">
							<el-button @click="loginTemplate('reg',isSearch)" type="text">没有账号？立即注册</el-button>
						</div>

					</div>
					<div class="loginReset_reset loginReset_rItem" v-if="loginType=='reset'">

						<div class="reset_title">重置密码</div>
						<div class="reset_inp">
							<div class="reset_inpitem">
								<el-input class="reset_phone" v-model="reset_phone" placeholder="请输入手机号"></el-input>
							</div>
							<div class="reset_inpitem">
								<div class="reset_piccode_tips pointer" @click="resetGetPicCode">
									<img :src="reset_codepic" />
								</div>
								<el-input class="reset_picCode" v-model="reset_picCode" placeholder="请输入图中验证码"></el-input>
							</div>
							<div class="reset_switchpicCode">看不清？点击图片更换验证码</div>
							<div class="reset_inpitem">
								<div class="reset_phonecode_tips pointer" @click="resetGetPhoneCode">
									{{reset_codetext}}
								</div>
								<el-input class="reset_phoneCode" v-model="reset_phoneCode" placeholder="请输入手机验证码"></el-input>
							</div>
							<div class="reset_inpitem">
								<el-input class="reset_password" v-model="reset_password" type="password" placeholder="请输入新密码(6-16位数字/字母组合,区分大小写)"></el-input>
							</div>

						</div>

						<div class="reset_resetBtn pointer" @click="sureResetPassword">确定重置</div>
						<div class="returnLogin">
							<el-button @click="loginTemplate('reg',isSearch)" type="text">没有账号？立即注册</el-button>
						</div>

					</div>

				</div>
			</section>
			<!--登录修改密码-->
			<!-- 登录页 修改密码
		<el-button @click="loginTemplate('login')">登录页</el-button>
		<el-button @click="loginTemplate('reg')">zhuce</el-button>
		<el-button @click="loginTemplate('reset')">修改密码</el-button> -->
			<!--注册-->
			<section class="reg flex" v-if="loginType=='reg'">
				<div class="flex_item reg_left flex_left">
					<img src="//frontend.originoo.com/originoo_web/login/regpic.png" alt="">

				</div>
				<div class="flex_item  reg_right flex_right">
					<div class="title_loginReg">
						<div class="title_loginReg_item pointer" @click="loginTemplate('login',isSearch)">登录</div>
						<div class="title_loginReg_item pointer active">注册</div>
					</div>
					<div class="reg1 regbox" v-if="regStep == 1">
						<div class="reg1_inp reg_inp">
							<div class="reg1_inpitem">
								<el-input class="reg_phone" v-model="reg_phone" placeholder="请输入手机号"></el-input>
							</div>
							<div class="reg1_inpitem">
								<div class="reg1_piccode_tips pointer" @click="regGetPicCode">
									<img :src="reg_codepic" />
								</div>
								<el-input class="reg1_picCode" v-model="reg_picCode" placeholder="请输入图中验证码"></el-input>
							</div>
							<div class="reg1_switchpicCode">看不清？点击图片更换验证码</div>
							<div class="reg1_inpitem">
								<div class="reg1_phonecode_tips pointer" @click="regGetPhoneCode">
									{{reg_codetext}}
								</div>
								<el-input class="reg_phoneCode" v-model="reg_phoneCode" placeholder="请输入手机验证码"></el-input>
							</div>
							<div class="reg1_inpitem">
								<el-input class="reg1_password" v-model="reg_password" type="password" placeholder="请输入密码（6-16位数字/字母组合，区分大小写）"></el-input>
							</div>

						</div>

						<div class="line">
							<img src="//frontend.originoo.com/originoo_web/login/reg1_line.png" />
						</div>

						<div class="reg1_nextBtn reg_nextBtn pointer" @click="reg1next">下一步</div>
					</div>
					<div class="reg2 regbox" v-if="regStep == 2">
						<div class="reg2_inp reg_inp">
							<div class="reg2_inpitem">
								<el-input class="reg2_companyName" v-model="reg_companyName" placeholder="请填写完整的企业名称"></el-input>
							</div>
							<div class="reg2_inpitem">
								<el-input class="reg2_name" v-model="reg_name" placeholder="请输入你的名称"></el-input>
							</div>
							<div class="reg2_inpitem reg2_industry_item reg2_industry_picNeedNum">
								<div class="reg2_industry_cover cover pointer" @click.stop.prevent="clickIndustry">
									<i class="el-icon-arrow-right"></i>
								</div>
								<el-input class="reg2_industry" v-model="reg_industry" placeholder="请选择您的行业"></el-input>
								<div class="reg2_industry_list list" id="reg2_industry_list">
									<span>广告策划</span>
									<span>快销品</span>
									<span>金融</span>
									<span>房地产</span>
									<span>出版印刷</span>
									<span>教育</span>
									<span>医疗</span>
									<span>互联网</span>
									<span>汽车</span>
									<span>其他</span>
								</div>

							</div>
							<div class="reg2_inpitem reg2_picNeedNum_item reg2_industry_picNeedNum">
								<div class="reg2_picNeedNum_cover cover pointer" @click.stop.prevent="clickPicNeedNum">
									<i class="el-icon-arrow-right"></i>
								</div>
								<el-input class="reg2_picNeedNum" v-model="reg_picNeedNum" placeholder="请选择您的图片需求量（张）"></el-input>
								<div class="reg2_picNeedNum_list list" id="reg2_picNeedNum_list">
									<span>2000以上</span>
									<span>500-2000</span>
									<span>100-500</span>
									<span>10-100</span>
									<span>10以下</span>
								</div>
							</div>

						</div>
						<div class="line">
							<img src="//frontend.originoo.com/originoo_web/login/reg2_line.png" />
						</div>
						<div class="reg_nextBtn reg2_nextBtn pointer" @click="reg2next">下一步</div>
						<div class="regSkip">
							<el-button @click="regSkip2" type="text">跳过此步骤</el-button>
						</div>

					</div>
					<div class="reg3 regbox" v-if="regStep == 3">
						<div class="tips1">您好！</div>
						<div class="tips2">如果跳过此步骤，</div>
						<div class="tips3">您只能得到个人授权，将无法进行企业商用</div>
						<div class="line">
							<img src="//frontend.originoo.com/originoo_web/login/reg2_line.png" />
						</div>
						<div class="reg_nextBtn reg3_nextBtn pointer" @click="reg3next">返回填写</div>
						<div class="regSkip">
							<el-button @click="regSkip3" type="text">确认跳过</el-button>
						</div>

					</div>
					<div class="reg4 regbox" v-if="regStep == 4">
						<div class="regSuccess">注册成功！</div>
						<div class="getCoupon">恭喜您获得500元优惠卷
							<el-button type="text" @click="nowUse">立即使用</el-button>
						</div>
						<div class="lookCoupon">可在【个人中心】-【优惠券】中查看</div>

						<div class="line">
							<img src="//frontend.originoo.com/originoo_web/login/reg3_line.png" />
						</div>
						<div class="reg_nextBtn pointer" @click="regLoginAccount">登录</div>

					</div>

				</div>

			</section>

		</el-dialog>

		<!--<el-dialog class="loginThird" title="提示" :visible.sync="loginThirdVisible" :close-on-click-modal="false" :close-on-press-escape="false" width="1064px">-->

		<div class="ThirdLoginBox">
			<div class="ThirdLoginBox-Main">
				<div class="CloseBox" @click="closeThirdLogin"><img src="//frontend.originoo.com/static/sites/originoo/img/iconclose_10f2f80.png"></div>
				<!-- 没有账号，创建账号 -->
				<div class="ThModel1">
					<div class="ThModel1-m1">创建您的锐景专有账号</div>
					<div class="ThModel1-m2"><input class="thirdipt1" type="text" placeholder="请输入手机号" /></div>
					<div class="ThModel1-m3"><input class="thirdipt2" type="text" placeholder="请输入图形验证码" /><img class="thirdUrl" :src="thirdUrl" onclick="getImgCode()"></div>
					<div class="ThModel1-m4"><input class="thirdipt3" type="text" placeholder="请输入手机验证码" /><button class="thirdSendTelCode" @click="getThirdTelCode">获取验证码</button></div>
					<div class="ThModel1-m5"><input class="thirdipt4" type="password" placeholder="请输入密码" /></div>
					<div class="ThModel1-m6"><button class="thirdRegisterBtn" @click="thirdUserRegister">确定</button></div>
					<div class="ThModel1-m7">已有账号？
						<a class="goAccount" @click="goAccount">绑定已有账号</a>
					</div>
				</div>
				<!-- 绑定已有的账号 -->
				<div class="ThModel2">
					<div class="ThModel1-m1">请绑定已有账号</div>
					<div class="ThModel1-m2"><input class="thirdipt5" type="text" placeholder="请输入手机号" /></div>
					<div class="ThModel1-m5"><input class="thirdipt6" type="password" placeholder="请输入密码" /></div>
					<div class="ThModel1-m6"><button class="thirdAlreadyBtn" @click="thirdUserAlready">确定</button></div>
					<div class="ThModel1-m7">没有账号？
						<a class="goNoAccount">创建账号</a>
					</div>
				</div>
			</div>
		</div>

		<!--</el-dialog>-->

	</div>
</template>
<script>
	import $axios from 'axios';
	import axios from 'axios';
	import {
		passwordReg,
		phoneReg,
	} from './../js/setConfig.js';
	import {
		setCookie,
		getCookie,
		delCookie
	} from './../js/handleCookie.js';
	import {
		postRegotherInfo
	} from './../../api/api.js';
	import {
		postAccountLogin,
		postRegAccount,
		getPhoneCode,
		postForgetPassword
	} from './../../api/accountapi.js';

	export default {

		data() {
			return {
				loginThirdVisible: false,

				loginVisible: false,
				loginType: '',

				login_phone: '',
				login_password: '',
				isAutoLogin: false,

				imgCodeToken: '',

				reset_phone: '',
				reset_phoneCode: '',
				reset_password: '',
				reset_picCode: '',
				reset_codetext: '获取验证码',
				reset_codepic: '445',
				reset_CountDown: true,

				regStep: 1,
				reg_phone: '',
				reg_phoneCode: '',
				reg_codetext: '获取验证码',
				reg_CountDown: true,

				reg_password: '',
				reg_picCode: '',
				reg_codepic: '755454',

				reg_companyName: '',
				reg_name: '',
				reg_industry: '',
				reg_picNeedNum: '',
				apiURL: "https://account.originoo.com/",
				thirdUrl: "",
				isSearch:'',
			}
		},
		watch: {

		},
		created() {},
		mounted() {},
		methods: {
			toGOQY(){
				$("#clickGOQY").click()
				// window.open("https://vip.originoo.com")
			},
			loginThird(type) {
				$('.ThirdLoginBox').show();
				$('.ThModel1').show();
				$('.ThModel2').hide();
				this.getImgCode()
				//				this.loginThirdVisible = true;
			},
			//第三方登录
			loginTemplate(type,isSearch) {
				console.log(type, 45,isSearch)
				this.isSearch = isSearch;

				if(type == 'reg') {
					this.regStep = 1;
					this.loginType = type;

					this.regAccount1()

				} else if(type == 'reset') {
					this.loginType = type;
					this.resetPassWord()

				} else if(type == 'login') {
					this.login_phone = '';
					this.login_password = '';
					this.isAutoLogin = false;
					this.loginType = type;
				} else {
					this.login_phone = '';
					this.login_password = '';
					this.isAutoLogin = false;
					this.loginType = 'login';
				}
				this.loginVisible = true;
			},

			loginAccount() {
				this.login_phone = this.login_phone.trim();
				this.login_password = this.login_password.trim();

				if(!this.login_phone) {
					this.$message.warning('手机号/邮箱不能为空')
					return
				}
				if(!this.login_password) {
					this.$message.warning('密码不能为空')
					return
				} else {
					if(!passwordReg.test(this.login_password)) {
						this.$message.error('密码格式错误!');
						return
					}
				}
				let params = {};
				params.login_phone = this.login_phone;
				params.login_password = this.login_password;
				params.isAutoLogin = this.isAutoLogin;
				this.loginWEB(params)
			},
			//登录模块的登录
			loginWEB(params) {
				//console.log('调用登录api', Base64)
				let par = {};
				par.username = params.login_phone;
				par.password = params.login_password;
				var that = this

				postAccountLogin(par).then(res => {
					//console.log(res.headers)
					//console.log(res.headers['originoo-authorization'], 444)

					that.$message.success('登录成功')
					let userName = params.login_phone;
					let token = res.headers['originoo-authorization'];
					let userInfoCode = res.headers['originoo-authorization'].substr(7).split(".")[1];
					let authorization = Base64.decode(userInfoCode); //base64解码
					let JsonInfo = eval('(' + authorization + ')'); //转化成json
					let userinfo = eval('(' + JsonInfo.sub + ')'); //用户的个人信息
					//console.log(JsonInfo)
					//console.log(userinfo)
					//console.log(params.isAutoLogin, '是否自动登录')

					if(params.isAutoLogin) {
						setCookie('isAutoLogin', 1, 1);
						setCookie('headImg', userinfo.headImage, 1); //cookie设置头像
						setCookie('id', userinfo.id, 1); //cookie设置id
						setCookie('username', userinfo.username, 1); //cookie设置用户名
						setCookie('userType', JsonInfo.scopes, 1); //cookie设置用户类型,数据为string类型
						setCookie('userAccount', userName, 1); //cookie设置用户账号
						//setCookie('userPassword', userPassword, 7); //cookie设置用户密码，加密
						setCookie('token', token, 1); //cookie设置token
					} else {
						setCookie('isAutoLogin', 0, 1); //cookie设置头像
						setCookie('headImg', userinfo.headImage); //cookie设置头像
						setCookie('id', userinfo.id); //cookie设置id
						setCookie('username', userinfo.username); //cookie设置用户名
						setCookie('userType', JsonInfo.scopes); //cookie设置用户类型,数据为string类型
						setCookie('userAccount', userName); //cookie设置用户账号
						setCookie('token', token); //cookie设置token
					}

					that.loginVisible = false;
					window.location.reload();
				}).catch(err => {

				})

			},

			//重置密码
			resetPassWord() {
				this.reset_codepic = '';
				this.resetGetPicCode();
				//console.log('重置密码')
				//				this.$message.info('重置密码')
				this.reset_phone = '';
				this.reset_phoneCode = '';
				this.reset_password = '';
				this.reset_picCode = '';
				this.reset_codetext = '获取验证码';

				this.imgCodeToken = '';
				this.reset_CountDown = true;

			},
			getImgCode() {
				this.getPicCode('thirdLogin')
			},
			resetGetPicCode() {
				//console.log('重置密码获取图片验证码')
				this.getPicCode('reset')
			},
			getPicCode(val) {
				//console.log("获取图形验证码")
				$axios.get(this.apiURL + 'register/imageCode', {
					responseType: 'arraybuffer'
				}).then(res => {
					let data = res.data;
					//console.log(res.headers, 255639)
					this.imgCodeToken = res.headers.token;
					let bytes = new Uint8Array(res.data);
					let len = bytes.byteLength;
					let srcdata = '';
					for(let i = 0; i < len; i++) {
						srcdata += String.fromCharCode(bytes[i]);
					}
					let src = "data:image/png;base64," + window.btoa(srcdata);
					if(val == 'reset') {
						this.reset_codepic = src;
					} else if(val == "reg") {
						this.reg_codepic = src;

					} else {
						this.thirdUrl = src
						setCookie('imageToken', res.headers.token)
					}
				}).catch(err => {
					this.$message.error(err)

				})
			},

			resetGetPhoneCode() {
				//console.log('获取手机验证码---重置密码')
				//判断手机号填写

				this.reset_phone = this.reset_phone.trim();
				this.reset_picCode = this.reset_picCode.trim();

				if(!this.reset_phone) {
					this.$message.warning('请输入手机号')
					return
				}
				if(!this.reset_picCode) {
					this.$message.warning('请输入图片验证码')
					return
				} else {
					if(this.reset_picCode.length != 4) {
						this.$message.warning('请填写4位图片验证码')
						return
					}
				}
				//判断验证码填写

				if(this.reset_CountDown) {
					let params = {};
					params.imageCode = this.reset_picCode;
					params.telNum = this.reset_phone;
					params.token = this.imgCodeToken;
					this.reset_codetext = '获取验证码';
					this.getPhoneCode(params, 'reset')
				} else {
					//console.log('正在执行倒计时')
				}

			},
			getPhoneCode(params, val) {
				let _this = this;
				_this.$axios({
					method: "post",
					url: _this.apiURL + 'register/sendSmsCode?imageCode=' + params.imageCode + '&telNum=' + params.telNum + '&token=' + params.token,
					data: params
				}).then(res => {
					if(val == 'reset') {
						this.reset_CountDown = false;
						//执行倒计时
						_this.reset_codetext = '60秒重新获取';
						let count = 59;
						let countDown = setInterval(() => {
							if(count === 0) {
								_this.reset_CountDown = true;
								_this.reset_codetext = '重新发送';
								clearInterval(countDown);
							} else {
								_this.reset_CountDown = false;
								_this.reset_codetext = count + '秒重新获取';
							}
							count--;
						}, 1000);
					} else {
						this.reg_CountDown = false;
						//执行倒计时
						_this.reg_codetext = '60秒重新获取';
						let count = 59;
						let countDown = setInterval(() => {
							if(count === 0) {
								_this.reg_CountDown = true;
								_this.reg_codetext = '重新发送';
								clearInterval(countDown);
							} else {
								_this.reg_CountDown = false;
								_this.reg_codetext = count + '秒重新获取';
							}
							count--;
						}, 1000);
					}

				}).catch(err => {
					_this.$message.error(err)

				})
			},

			sureResetPassword() {
				//确定重置密码
				this.reset_phone = this.reset_phone.trim();
				this.reset_phoneCode = this.reset_phoneCode.trim();
				this.reset_password = this.reset_password.trim();
				if(!this.reset_phone) {
					this.$message.warning('请输入手机号')
					return
				}
				if(!this.reset_phoneCode) {
					this.$message.warning('请输入验证码')
					return
				} else {
					// if(this.reset_phoneCode.length != 4) {
					// 	this.$message.warning('请填写4位验证码')
					// 	return
					// }
				}
				if(!this.reset_password) {
					this.$message.warning('密码不能为空')
					return
				} else {
					if(!passwordReg.test(this.reset_password)) {
						this.$message.error('密码格式错误!');
						return
					}
				}

				let params = {};
				params.phoneNumber = this.reset_phone;
				params.smsCode = this.reset_phoneCode;
				params.newPassword = this.reset_password;

				postForgetPassword(params).then(res => {
					this.$message.success('密码重置成功');
					this.loginTemplate('login',isSearch)
				}).catch(err => {
					//console.log(err, '错误1323')
				})

			},
			regAccount1() {
				//获取图片验证码
				this.reg_codepic = '';
				this.getPicCode('reg');
				this.reg_CountDown = true;
				this.reg_phone = '';
				this.reg_picCode = '';
				this.reg_codetext = '获取验证码';
				this.reg_phoneCode = '';
				this.reg_password = '';
				this.imgCodeToken = '';
			},
			regGetPicCode() {
				this.getPicCode('reg');
			},

			regGetPhoneCode() {
				//console.log('获取验证码---注册')
				this.reg_phone = this.reg_phone.trim();
				this.reg_picCode = this.reg_picCode.trim();

				if(!this.reg_phone) {
					this.$message.warning('请输入手机号')
					return
				}
				if(!phoneReg.test(this.reg_phone)) {
					this.$message.error('手机号格式错误!');
					return
				}



				if(!this.reg_picCode) {
					this.$message.warning('请输入图片验证码')
					return
				} else {
					if(this.reg_picCode.length != 4) {
						this.$message.warning('请填写4位图片验证码')
						return
					}
				}

				if(this.reg_CountDown) {
					let params = {};
					params.imageCode = this.reg_picCode;
					params.telNum = this.reg_phone;
					params.token = this.imgCodeToken;
					this.reg_codetext = '获取验证码';
					this.getPhoneCode(params, 'reg')
				} else {
					//					//console.log('正在执行道济是reg')
				}

			},
			reg1next() {
				//console.log('reg1下一步')

				this.reg_phone = this.reg_phone.trim();
				this.reg_picCode = this.reg_picCode.trim();
				this.reg_phoneCode = this.reg_phoneCode.trim();
				this.reg_password = this.reg_password.trim();

				if(!this.reg_phone) {
					this.$message.warning('请输入手机号')
					return
				}
				if(!phoneReg.test(this.reg_phone)) {
					this.$message.error('手机号格式错误!');
					return
				}




				if(!this.reg_picCode) {
					this.$message.warning('请输入验证码')
					return
				} else {
					// if(this.reg_picCode.length != 4) {
					// 	this.$message.warning('请填写4位图片验证码')
					// 	return
					// }
				}
				if(!this.reg_phoneCode) {
					this.$message.warning('请输入验证码')
					return
				} else {
					// if(this.reg_phoneCode.length != 4) {
					// 	this.$message.warning('请填写4位验证码')
					// 	return
					// }
				}
				if(!this.reg_password) {
					this.$message.warning('密码不能为空')
					return
				} else {
					if(!passwordReg.test(this.reg_password)) {
						this.$message.error('密码格式错误!');
						return
					}
				}

				let params = {};
				params.telNum = this.reg_phone;
				params.smsCode = this.reg_phoneCode;
				params.password = this.reg_password;

				postRegAccount(params).then(res => {
					this.regStep = 2;
					this.reg_companyName = '';
					this.reg_name = '';
					this.reg_industry = '';
					this.reg_picNeedNum = '';
				})

			},
			reg2next() {
				//console.log('reg2下一步')
				this.reg_companyName = this.reg_companyName.trim();

				this.reg_name = this.reg_name.trim();
				this.reg_industry = this.reg_industry.trim();
				this.reg_picNeedNum = this.reg_picNeedNum.trim();

				if(!this.reg_companyName) {
					this.$message.warning('请填写企业名称')
					return
				}
				if(!this.reg_name) {
					this.$message.warning('请填写你的名称')
					return
				}
				if(!this.reg_industry) {
					this.$message.warning('请选择您的行业')
					return
				}
				if(!this.reg_picNeedNum) {
					this.$message.warning('请选择您的图片需求量')
					return
				}
                this.regloginWEB()
				this.regStep = 4;
			},

			nowUse() {
				//console.log('立即使用,登录并跳到优惠卷页面')
                window.location.href ='/account/coupon/';
				//				this.regLoginAccount();
			},

			regLoginAccount() {
				//console.log('注册完成后的登录')
//				let params = {};
//				params.login_phone = this.reg_phone;
//				params.login_password = this.reg_password;
//				params.isAutoLogin = false;
	            this.loginVisible = false;

			},

			//注册模块的登录
			regloginWEB() {
				//console.log('调用登录api', Base64)
				let par = {};
				par.username = this.reg_phone;
				par.password = this.reg_password;
				var that = this

				postAccountLogin(par).then(res => {
					//console.log(res.headers)
					//console.log(res.headers['originoo-authorization'], 444)
					let userName = this.reg_phone;
					let token = res.headers['originoo-authorization'];
					let userInfoCode = res.headers['originoo-authorization'].substr(7).split(".")[1];
					let authorization = Base64.decode(userInfoCode); //base64解码
					let JsonInfo = eval('(' + authorization + ')'); //转化成json
					let userinfo = eval('(' + JsonInfo.sub + ')'); //用户的个人信息
					setCookie('isAutoLogin', 0, 1); //cookie设置头像
					setCookie('headImg', userinfo.headImage); //cookie设置头像
					setCookie('id', userinfo.id); //cookie设置id
					setCookie('username', userinfo.username); //cookie设置用户名
					setCookie('userType', JsonInfo.scopes); //cookie设置用户类型,数据为string类型
					setCookie('userAccount', userName); //cookie设置用户账号
					setCookie('token', token); //cookie设置token
					var param = {
						"companyName": that.reg_companyName,
						"contact": that.reg_name,
						"demand": that.reg_picNeedNum,
						"vocation": that.reg_industry
					}
					//console.log('调用接口')
					postRegotherInfo(param).then(res => {
						that.loginVisible = false;
					    window.location.reload();
					})


				}).catch(err => {
					//console.log(err, 355)
				})

			},

			reg3next() {
				//console.log('返回填写')
				this.regStep = 2;
			},
			regSkip2() {
				//console.log('跳过此步骤 reg2')
				this.regStep = 3;
			},
			regSkip3() {
				//console.log('确认跳过')
				this.regStep = 4;
			},
			clickIndustry() {

				if($('.reg2_industry_list').css("display") == 'none') {
					$('.reg2_picNeedNum_list').slideUp(200);
					$('.reg2_industry_list').slideDown(200);
				} else {
					$('.reg2_industry_list').slideUp(200);
				}
				this.handleJQEvent()
			},
			clickPicNeedNum() {


				if($('.reg2_picNeedNum_list').css("display") == 'none') {
					$('.reg2_industry_list').slideUp(200);
					$('.reg2_picNeedNum_list').slideDown(200);
				} else {
					$('.reg2_picNeedNum_list').slideUp(200);
				}
				this.handleJQEvent()
			},
			handleJQEvent() {
				let _this = this;
				$('.reg2_industry_list span').click(function() {
					event.stopPropagation();
					$(this).addClass('active').siblings().removeClass('active');
					_this.handleIndustry_val($(this).text())
					$('.reg2_industry_list').slideUp(200);
				})

				$('.reg2_picNeedNum_list span').click(function() {
					event.stopPropagation();
					$(this).addClass('active').siblings().removeClass('active');
					_this.handlePicNeedNum_val($(this).text())
					$('.reg2_picNeedNum_list').slideUp(200);
				})

				$('body').click(function(e) {

					let indutry = $('.reg2_industry_list').css('display') == 'block';
					let picneednum = $('.reg2_picNeedNum_list').css('display') == 'block';
					//console.log(e)
					let targetId = e.target.id;
					let ip = targetId == 'reg2_industry_list' || targetId == 'reg2_picNeedNum_list';
					if(ip) {
						//console.log(3006)
					} else {
						if(indutry || picneednum) {
							//console.log(300)
							$('.reg2_industry_list').slideUp(200);
							$('.reg2_picNeedNum_list').slideUp(200);
						}
					}

				});

			},
			handleIndustry_val(text) {
				this.reg_industry = text;
			},
			handlePicNeedNum_val(text) {
				this.reg_picNeedNum = text;
			},
			/**********************************第三方注册账号/绑定账号***********************************/
			//关闭弹框
			closeThirdLogin() {
				setCookie('qqToken', "", -1);
				setCookie('wechatToken', "", -1);
				setCookie('thirdlogintype', "", -1);
				$('.ThirdLoginBox').hide();
				$('.ThModel1').hide();
				$('.ThModel2').hide();
			},

			goAccount() {
				$('.ThModel1').hide();
				$('.ThModel2').show();
			},
			goNoAccount() {
				$('.ThModel1').show();
				$('.ThModel2').hide();
			},

			//点击第三方登录的创建专有账号的确定按钮
			thirdUserRegister() {
				if($('.thirdipt1').val() == "") {
					$.message({
						message: '手机号不能为空！',
						type: 'error'
					});
					return;
				}
				if($('.thirdipt2').val() == "") {
					$.message({
						message: '图形验证码不能为空！',
						type: 'error'
					});
					return;
				}
				if($('.thirdipt3').val() == "") {
					$.message({
						message: '手机验证码不能为空！',
						type: 'error'
					});
					return;
				}
				if($('.thirdipt4').val() == "") {
					$.message({
						message: '密码不能为空！',
						type: 'error'
					});
					return;
				}
				var param = {
					"accessToken": getCookie('qqToken'),
					"password": $('.thirdipt4').val(),
					"phoneNumber": $('.thirdipt1').val(),
					"smsCode": $('.thirdipt3').val()
				};
				if(getCookie('thirdlogintype') == 'qq') {
					var thurl = this.apiURL + 'register/qqThirdRegister'
				} else if(getCookie('thirdlogintype') == 'wechat') {
					var thurl = this.apiURL + 'register/wxThirdRegister'
				}
				$.ajax({
					type: "POST",
					headers: {
						'Content-Type': 'application/json;charset=utf8'
					},
					url: thurl,
					data: JSON.stringify(param),
					dataType: "json",
					success: function(res) {
						setCookie('qqToken', "", -1);
						setCookie('wechatToken', "", -1);
						setCookie('thirdlogintype', "", -1);
						// res.Authorization
						//						//console.log(res['Originoo-Authorization']);
						var token = res['Originoo-Authorization'];
						var userInfoCode = res['Originoo-Authorization'].substr(7).split(".")[1];
						var authorization = Base64.decode(userInfoCode); //base64解码
						var JsonInfo = eval('(' + authorization + ')'); //转化成json
						var userinfo = eval('(' + JsonInfo.sub + ')'); //用户的个人信息
						//console.log(JsonInfo)
						setCookie('isAutoLogin', 1, 1);
						setCookie('headImg', userinfo.headImage, 1); //cookie设置头像
						setCookie('id', userinfo.id, 1); //cookie设置id
						setCookie('username', userinfo.username, 1); //cookie设置用户名
						setCookie('userType', JsonInfo.scopes, 1); //cookie设置用户类型,数据为string类型
						setCookie('userAccount', $('.thirdipt1').val(), 1); //cookie设置用户账号
						//						setCookie('userPassword', $('.thirdipt4').val(), 1); //cookie设置用户密码，加密
						setCookie('token', token, 1); //cookie设置token
						$('.HeadRight-m4-headimgBox img').attr('src', userinfo.headImage)
						$('.HeadRight-m3').hide();
						$('.isPersonShow').css('display', 'flex');
						$('.ThirdLoginBox').hide();
						$('.ThModel1').hide();
						$('.ThModel2').hide();
						window.location.reload();
					},
					error: function(error) {
						//console.log(error);
						// $.message({
						//     message: error.responseJSON.message,
						//     type: 'error'
						// });

					}
				});
			},

			thirdUserAlready() {
				if($('.thirdipt5').val() == "") {
					$.message({
						message: '手机号不能为空！',
						type: 'error'
					});
					return;
				}
				if($('.thirdipt6').val() == "") {
					$.message({
						message: '密码不能为空！',
						type: 'error'
					});
					return;
				}
				if(getCookie('thirdlogintype') == 'qq') {
					var thurl = this.apiURL + 'register/qqThirdBinding';
					var thToken = getCookie('qqToken');
				} else if(getCookie('thirdlogintype') == 'wechat') {

					var thurl = this.apiURL + 'register/wxThirdBinding';
					var thToken = getCookie('wechatToken');
				}
				var param = {
					"accessToken": thToken,
					"password": $('.thirdipt6').val(),
					"username": $('.thirdipt5').val()
				}
				//console.log("开始绑定")
				$.ajax({
					type: "POST",
					headers: {
						'Content-Type': 'application/json;charset=utf8'
					},
					url: thurl,
					data: JSON.stringify(param),
					dataType: "json",
					success: function(res) {
						setCookie('qqToken', "", 1);
						setCookie('wechatToken', "", 1);
						setCookie('thirdlogintype', "", 1);
						//console.log("绑定成功")
						// res.Authorization
						//console.log(res['Originoo-Authorization']);
						var token = res['Originoo-Authorization'];
						var userInfoCode = token.substr(7).split(".")[1];
						var authorization = Base64.decode(userInfoCode); //base64解码
						var JsonInfo = eval('(' + authorization + ')'); //转化成json
						var userinfo = eval('(' + JsonInfo.sub + ')'); //用户的个人信息
						//console.log(JsonInfo)
						setCookie('isAutoLogin', 1, 1);
						setCookie('headImg', userinfo.headImage, 1); //cookie设置头像
						setCookie('id', userinfo.id, 1); //cookie设置id
						setCookie('username', userinfo.username, 1); //cookie设置用户名
						setCookie('userType', JsonInfo.scopes, 1); //cookie设置用户类型,数据为string类型
						setCookie('token', token, 1); //cookie设置token
						$('.HeadRight-m4-headimgBox img').attr('src', userinfo.headImage);
						$('.HeadRight-m3').hide();
						$('.isPersonShow').css('display', 'flex');
						$('.ThirdLoginBox').hide();
						$('.ThModel1').hide();
						$('.ThModel2').hide();
						window.location.reload();
					},
					error: function(error) {
						//console.log(error)
						//console.log("绑定失败")

					}
				});
			},

			//第三方登录后创建新账号发送短信验证码
			getThirdTelCode() {
				if($('.thirdipt1').val() == "") {
					$.message({
						message: '手机号不能为空！',
						type: 'error'
					});
					return;
				}
				if($('.thirdipt1').val() == "") {
					$.message({
						message: '图形验证码不能为空！',
						type: 'error'
					});
					return;
				}
				var tel = $('.thirdipt1').val();
				var imgCode = $('.thirdipt2').val();
				var imgtoken = getCookie('imageToken');
				this.$axios({
						method: "POST",
						headers: {
							'Content-Type': 'application/json;charset=utf8'
						},
						url: this.apiURL + 'register/sendSmsCode?telNum=' + tel + '&imageCode=' + imgCode + "&token=" + imgtoken,
					}).then(res => {
						this.$message.success('发送成功!');
						let count = 60;
						const countDown = setInterval(() => {
							if(count === 0) {
								$('.thirdSendTelCode').text('重新发送').removeAttr('disabled');
								clearInterval(countDown);
							} else {
								$('.thirdSendTelCode').attr('disabled', true);
								$('.thirdSendTelCode').text(count + '秒重新获取');
							}
							count--;
						}, 1000);

					})
					.catch(function(err) {
						//console.log(err, "ce")

						that.$message.error(error.response.data.message)
					})

			}
		}
	}
</script>

<style lang="scss">
	@import "./../css/color.scss";
	.loginTemplate {
		/*第三方登录*/
		.loginThird {
			.el-dialog {
				margin-top: 10vh !important;
				/*width:1064px;
				height:634px;
				position: absolute;
				margin-top: -317px !important;
				top:50%;
				left: calc(50% - 532px);*/
				.el-dialog__header {
					display: none;
				}
				.el-dialog__body {
					padding: 0;
					height: 634px;
					position: relative;
					.loginThirdClose {
						position: absolute;
						top: 20px;
						right: 20px;
						i {
							font-size: 30px;
							color: $dialog_color_close;
						}
					}
				}
			}
		}
		/*第三方登录*/
		.el-dialog {
			margin-top: 10vh !important;
			width: 1064px;
			height: 634px;
			position: absolute;
			margin-top: -317px !important;
			top: 50%;
			left: calc(50% - 532px);
			.el-dialog__header {
				display: none;
			}
			.el-dialog__body {
				padding: 0;
				height: 634px;
				position: relative;
				.loginResetRegClose {
					position: absolute;
					top: 20px;
					right: 20px;
					i {
						font-size: 30px;
						color: $dialog_color_close;
					}
					.iconClosed {
						width: 25px;
						height: 25px;
					}
				}
				.flex {
					display: flex;
					flex-wrap: nowrap;
					.flex_item {
						flex-grow: 0;
						flex-shrink: 0;
						&.flex_left {
							flex-basis: 634px;
							height: 634px;
							img {
								width: 100%;
								height: 100%;
								object-fit: cover;
							}
						}
						&.flex_right {
							flex-basis: 430px;
							padding: 60px 60px 37px 60px;
							box-sizing: border-box;
						}
					}
					&.loginReset {
						.loginReset_left {}
						.loginReset_right {
							.loginReset_rItem {
								&.loginReset_login {
									.title_loginReg {
										height: 29px;
										.title_loginReg_item {
											color: $font_color_B2;
											line-height: 29px;
											display: inline-block;
											vertical-align: top;
											font-size: $font_size_18;
											font-weight: $font_weight_700;
											margin-right: 20px;
											&.active {
												color: $font_color_35;
												border-bottom-width: 2px;
												border-bottom-style: solid;
												-webkit-border-image: $border_graduals_webkit;
												-moz-border-image: $border_graduals_moz;
												-ms-border-image: $border_graduals_ms;
												-o-border-image: $border_graduals_o;
												border-image: $border_graduals_;
											}
										}
									}
									.login_title {
										margin-top: 35px;
										height: 28px;
										line-height: 28px;
										color: $font_color_35;
										font-size: $font_size_20;
										font-weight: $font_weight_700;
									}
									.login_personalCompany{
										width:128px;
										display: flex;
										background: #EEEEEE;
										text-align: center;
										border-radius: 15px;
										margin-top: 35px;
										div{

											height: 30px;
											line-height: 30px;
											font-size: 14px;
										}
										.login_personal{
											color: #FFFFFF;
											background: #353535;
											border-radius: 15px;
											width:68px;
										}
										.login_company{
											width:58px;
											color: #353535;
											background: transparent;
											a{
												color: #353535;
											}
										}
									}
									.login_inp {
										margin-top: 15px;
										.el-input {
											margin-top: 10px;
											color: $font_color_35;
											.el-input__inner {
												border-top: none;
												border-left: none;
												border-right: none;
												border-radius: $border-radius_0;
												border-bottom-color: #EEEEEE;
												padding: 10px 0px;
												line-height: 40px;
												height: 40px;
												font-size: 14px;
												&:focus {
													border-color: $border_bottom_color_FF7545;
												}
											}
										}
									}
									.rememberForget {
										margin-top: 10px;
										height: 17px;
										line-height: 17px;
										.el-checkbox {
											color: $font_color_B2;
											.el-checkbox__input {
												.el-checkbox__inner {
													border-color: $font_color_88;
												}
												&.is-checked {
													.el-checkbox__inner {
														background: $bgd_graduals_webkit;
														background: $bgd_graduals_moz;
														background: $bgd_graduals_ms;
														background: $bgd_graduals_o;
														background: $bgd_graduals_;
														border: none;
														&:after {
															left: 5px;
															top: 2px;
														}
													}
												}
												&.is-checked+.el-checkbox__label {
													color: $font_color_B2;
												}
											}
										}
										.el-button {
											color: $font_color_FF7545;
											float: right;
											height: 17px;
											padding: 0px;
											line-height: 17px;
										}
									}
									.thirdLogin {
										margin-top: 66px;
										.thirdLogin_title {
											color: $font_color_B2;
											font-size: $font_size_12;
											height: 17px;
											line-height: 17px;
											text-align: center;
										}
										.third_imgBox {
											margin-top: 14px;
											font-size: $font_size_0;
											text-align: center;
											a {
												display: inline-block;
												width: 32px;
												height: 32px;
												vertical-align: top;
												background-size: cover;
												&.qq_login {
													background-image: url('//frontend.originoo.com/originoo_web/login/qq.png');
													&:hover {
														background-image: url('//frontend.originoo.com/originoo_web/login/qq_hover.png');
													}
												}
												&.wx_login {
													margin-left: 8px;
													margin-right: 8px;
													background-image: url('//frontend.originoo.com/originoo_web/login/wx.png');
													&:hover {
														background-image: url('//frontend.originoo.com/originoo_web/login/wx_hover.png');
													}
												}
												&.sina_login {
													background-image: url('//frontend.originoo.com/originoo_web/login/sina.png');
													&:hover {
														background-image: url('//frontend.originoo.com/originoo_web/login/sina_hover.png');
													}
												}
											}
										}
									}
									.loginBtn {
										margin: 29px auto 0;
										width: 172px;
										height: 55px;
										line-height: 55px;
										border-radius: $border-radius_4;
										text-align: center;
										color: $font_color_FF;
										font-weight: $font_weight_700;
										font-size: $font_size_18;
										background: $bgd_graduals_webkit;
										background: $bgd_graduals_moz;
										background: $bgd_graduals_ms;
										background: $bgd_graduals_o;
										background: $bgd_graduals_;
										&:hover {
											background: $bgd_graduals_webkit_hover;
											background: $bgd_graduals_moz_hover;
											background: $bgd_graduals_ms_hover;
											background: $bgd_graduals_o_hover;
											background: $bgd_graduals__hover;
										}
									}
									.noReg {
										margin-top: 6px;
										text-align: center;
										.el-button {
											padding: 0px;
											font-size: $font_size_12;
											color: $font_color_B2;
											height: 17px;
											line-height: 17px;
										}
									}
								}
								&.loginReset_reset {
									.reset_title {
										width: 72px;
										line-height: 29px;
										font-size: $font_size_18;
										font-weight: $font_weight_700;
										color: $font_color_35;
										border-bottom-width: 2px;
										border-bottom-style: solid;
										-webkit-border-image: $border_graduals_webkit;
										-moz-border-image: $border_graduals_moz;
										-ms-border-image: $border_graduals_ms;
										-o-border-image: $border_graduals_o;
										border-image: $border_graduals_;
									}
									.reset_inp {
										margin-top: 78px;
										.el-input {
											margin-top: 10px;
											color: $font_color_35;
											.el-input__inner {
												border-top: none;
												border-left: none;
												border-right: none;
												border-radius: $border-radius_0;
												border-bottom-color: #EEEEEE;
												padding: 10px 0px;
												line-height: 40px;
												height: 40px;
												&:focus {
													border-color: $border_bottom_color_FF7545;
												}
											}
											&.reset_phone {}
											&.reset_phoneCode {
												.el-input__inner {
													padding-right: 95px;
												}
											}
											&.reset_password {}
											&.reset_picCode {
												.el-input__inner {
													padding-right: 100px;
												}
											}
										}
										.reset_inpitem {
											position: relative;
											.reset_phonecode_tips {
												width: 90px;
												height: 20px;
												line-height: 20px;
												font-size: $font_size_14;
												color: $font_color_FF7545;
												text-align: right;
												position: absolute;
												right: 0;
												bottom: 10px;
												z-index: 3000;
											}
											.reset_piccode_tips {
												width: 93px;
												height: 30px;
												line-height: 30px;
												position: absolute;
												right: 0;
												bottom: 4px;
												z-index: 3000;
												img {
													width: 93px;
													height: 30px;
												}
											}
										}
									}
									.reset_switchpicCode {
										margin-top: 10px;
										height: 17px;
										line-height: 17px;
										font-size: $font_size_12;
										color: $font_color_B2;
									}
									.reset_resetBtn {
										/*margin-top: 121px;*/
										margin: 121px auto 0;
										text-align: center;
										width: 172px;
										height: 55px;
										line-height: 55px;
										border-radius: $border-radius_4;
										color: $font_color_FF;
										font-size: $font_size_18;
										font-weight: $font_weight_700;
										background: $bgd_graduals_webkit;
										background: $bgd_graduals_moz;
										background: $bgd_graduals_ms;
										background: $bgd_graduals_o;
										background: $bgd_graduals_;
										&:hover {
											background: $bgd_graduals_webkit_hover;
											background: $bgd_graduals_moz_hover;
											background: $bgd_graduals_ms_hover;
											background: $bgd_graduals_o_hover;
											background: $bgd_graduals__hover;
										}
									}
									.returnLogin {
										margin-top: 6px;
										text-align: center;
										.el-button {
											padding: 0px;
											font-size: $font_size_12;
											color: $font_color_B2;
											height: 17px;
											line-height: 17px;
										}
									}
								}
							}
						}
					}
					&.reg {
						.reg_left {}
						.reg_right {
							.title_loginReg {
								height: 29px;
								.title_loginReg_item {
									color: $font_color_B2;
									line-height: 29px;
									display: inline-block;
									vertical-align: top;
									font-size: $font_size_18;
									font-weight: $font_weight_700;
									margin-right: 20px;
									&.active {
										color: $font_color_35;
										border-bottom-width: 2px;
										border-bottom-style: solid;
										-webkit-border-image: $border_graduals_webkit;
										-moz-border-image: $border_graduals_moz;
										-ms-border-image: $border_graduals_ms;
										-o-border-image: $border_graduals_o;
										border-image: $border_graduals_;
									}
								}
							}
							.regbox {
								margin-top: 78px;
								.line {
									width: 310px;
									margin-top: 74px;
									line-height: 14px;
									img {
										width: 310px;
										height: 13px;
									}
								}
								.reg_nextBtn {
									margin: 40px auto 0;
									text-align: center;
									width: 172px;
									height: 55px;
									line-height: 55px;
									letter-spacing: 1px;
									border-radius: $border-radius_4;
									color: $font_color_FF;
									font-size: $font_size_18;
									font-weight: $font_weight_700;
									background: $bgd_graduals_webkit;
									background: $bgd_graduals_moz;
									background: $bgd_graduals_ms;
									background: $bgd_graduals_o;
									background: $bgd_graduals_;
									&:hover {
										background: $bgd_graduals_webkit_hover;
										background: $bgd_graduals_moz_hover;
										background: $bgd_graduals_ms_hover;
										background: $bgd_graduals_o_hover;
										background: $bgd_graduals__hover;
									}
								}
								.reg_inp {}
								&.reg1 {
									.line {
										margin-top: 68px;
									}
									.reg1_nextBtn {}
									.el-input {
										margin-top: 10px;
										color: $font_color_35;
										.el-input__inner {
											border-top: none;
											border-left: none;
											border-right: none;
											border-radius: $border-radius_0;
											border-bottom-color: #EEEEEE;
											padding: 10px 0px;
											line-height: 40px;
											height: 40px;
											&:focus {
												border-color: $border_bottom_color_FF7545;
											}
										}
										&.reg1_phone {}
										&.reg1_phoneCode {
											.el-input__inner {
												padding-right: 95px;
											}
										}
										&.reg1_password {}
										&.reg1_picCode {
											.el-input__inner {
												padding-right: 100px;
											}
										}
									}
									.reg1_inp {
										.reg1_inpitem {
											position: relative;
											.reg1_phonecode_tips {
												width: 90px;
												height: 20px;
												line-height: 20px;
												font-size: $font_size_14;
												color: $font_color_FF7545;
												text-align: right;
												position: absolute;
												right: 0;
												bottom: 10px;
												z-index: 3000;
											}
											.reg1_piccode_tips {
												width: 93px;
												height: 30px;
												line-height: 30px;
												position: absolute;
												right: 0;
												bottom: 4px;
												z-index: 3000;
												img {
													width: 93px;
													height: 30px;
												}
											}
										}
									}
									.reg1_switchpicCode {
										margin-top: 10px;
										height: 17px;
										line-height: 17px;
										font-size: $font_size_12;
										color: $font_color_B2;
									}
								}
								&.reg2 {
									.el-input {
										margin-top: 10px;
										color: $font_color_35;
										.el-input__inner {
											border-top: none;
											border-left: none;
											border-right: none;
											border-radius: $border-radius_0;
											border-bottom-color: #EEEEEE;
											padding: 10px 0px;
											line-height: 40px;
											height: 40px;
											&:focus {
												border-color: $border_bottom_color_FF7545;
											}
										}
										&.reg2_companyName {}
										&.reg2_name {}
									}
									.reg2_inp {
										.reg2_inpitem {
											position: relative;
											&.reg2_industry_picNeedNum {
												.cover {
													position: absolute;

													top: 10px;
													left: 0px;
													width: 310px;
													height: 40px;
													/*background: #57D6D6;*/
													i {
														position: absolute;
														right: 10px;
														top: 14px;
														color: $font_color_B2;
														font-size: $font_size_16;
													}
												}
												.list {
													display: none;
													position: absolute;

													top: 49px;
													left: 0px;
													width: 310px;
													height: 170px;
													padding: 0px 16px;
													box-shadow: 0px 2px 12px 0px rgba(0, 0, 0, 0.06);
													background: $background_FF;
													box-sizing: border-box;
													font-size: $font_size_0;
													span {
														font-size: $font_size_14;
														cursor: pointer;
														display: inline-block;
														vertical-align: top;
														box-sizing: border-box;
														color: $font_color_88;
														font-size: $font_size_14;
														border: 1px solid $border_color_EE;
														border-radius: $border-radius_20;
														margin-top: 10px;
														width: 86px;
														text-align: center;
														height: 30px;
														line-height: 30px;
														&:nth-child(3n-1) {
															margin-left: 10px;
															margin-right: 10px;
														}
														&.active {
															color: $font_color_FF;
															background: $background_35;
														}
													}
												}
												&.reg2_picNeedNum_item {
													.reg2_picNeedNum_cover {
														z-index: 500;
													}
													.reg2_picNeedNum_list {
														height: 90px;
														z-index: 500;
													}
												}
												&.reg2_industry_item {
													.reg2_industry_cover {
														z-index: 1000;
													}
													.reg2_industry_list {
														z-index: 1000;

													}
												}
											}
										}
									}
									.reg2_nextBtn {}
									.regSkip {
										margin-top: 6px;
										text-align: center;
										.el-button {
											padding: 0px;
											font-size: $font_size_12;
											color: $font_color_B2;
											height: 17px;
											line-height: 17px;
										}
									}
								}
								&.reg3 {
									margin-top: 35px;
									.tips1 {
										color: $font_color_35;
										font-size: $font_size_20;
										margin-bottom: 35px;
										font-weight: $font_weight_700;
									}
									.tips2,
									.tips3 {
										color: $font_color_35;
										line-height: 22px;
										font-size: $font_size_16;
									}
									.tips3 {
										margin-top: 10px;
									}
									.line {
										margin-top: 225px;
									}
									.regSkip {
										margin-top: 6px;
										text-align: center;
										.el-button {
											padding: 0px;
											font-size: $font_size_12;
											color: $font_color_B2;
											height: 17px;
											line-height: 17px;
										}
									}
								}
								&.reg4 {
									margin-top: 35px;
									.regSuccess {
										font-size: $font_size_20;
										color: $font_color_35;
										font-weight: $font_weight_700;
										line-height: 28px;
									}
									.getCoupon {
										color: $font_color_35;
										font-size: $font_size_16;
										margin-top: 35px;
										line-height: 22px;
										.el-button {
											padding: 0;
											font-size: $font_size_16;
											color: $font_color_FF7545;
											float: right;
											line-height: 22px;
										}
									}
									.lookCoupon {
										font-size: $font_size_12;
										color: $font_color_B2;
										line-height: 17px;
										clear: both;
										margin-top: 6px;
									}
								}
							}
						}
					}
				}
			}
		}
	}

	.ThirdLoginBox {
		background: rgba(0, 0, 0, 0.3);
		position: fixed;
		left: 0;
		top: 0;
		bottom: 0;
		right: 0;
		z-index: 2002;
		width: 100%;
		min-width: 1200px;
		overflow: auto;
		height: 100%;
		display: none;
	}

	.ThirdLoginBox-Main {
		position: absolute;
		left: 50%;
		top: 50%;
		width: 500px;
		margin-left: -250px;
		margin-top: -188px;
		background: white;
		border-radius: 5px;
		box-sizing: border-box;
		padding: 20px 10px;
	}

	.CloseBox {
		width: 100%;
		text-align: right;
	}

	.CloseBox img {
		width: 25px;
		height: 25px;
		cursor: pointer;
	}

	.ThModel1 {
		display: none;
	}

	.ThModel2 {
		display: none;
	}

	.ThModel1-m1 {
		width: 100%;
		text-align: center;
		font-weight: bold;
		color: #353535;
	}

	.ThModel1-m2 {
		text-align: center;
		width: 70%;
		margin: auto;
		border: 1px solid #eee;
		margin-top: 15px;
	}

	.ThModel1-m2 input {
		width: 100%;
		height: 35px;
		line-height: 35px;
		outline: none;
		box-sizing: border-box;
		padding: 0 5px;
	}

	.ThModel1-m3 {
		text-align: center;
		width: 70%;
		margin: auto;
		border: 1px solid #eee;
		display: flex;
		justify-content: space-between;
		margin-top: 15px;
	}

	.ThModel1-m3 input {
		width: 60%;
		height: 35px;
		line-height: 35px;
		outline: none;
		box-sizing: border-box;
		padding: 0 5px;
	}

	.ThModel1-m3 img {
		width: 38%;
		height: 35px;
	}

	.ThModel1-m4 {
		text-align: center;
		width: 70%;
		margin: auto;
		border: 1px solid #eee;
		display: flex;
		justify-content: space-between;
		margin-top: 15px;
	}

	.ThModel1-m4 input {
		width: 60%;
		height: 35px;
		line-height: 35px;
		outline: none;
		box-sizing: border-box;
		padding: 0 5px;
	}

	.ThModel1-m4 button {
		width: 38%;
		height: 35px;
		outline: none;
		cursor: pointer;
	}

	.ThModel1-m5 {
		text-align: center;
		width: 70%;
		margin: auto;
		border: 1px solid #eee;
		margin-top: 15px;
	}

	.ThModel1-m5 input {
		width: 100%;
		height: 35px;
		line-height: 35px;
		outline: none;
		box-sizing: border-box;
		padding: 0 5px;
	}

	.ThModel1-m6 {
		text-align: center;
		width: 70%;
		margin: auto;
		margin-top: 15px;
	}

	.ThModel1-m6 button {
		width: 100%;
		height: 35px;
		box-sizing: border-box;
		background: linear-gradient(-45deg, rgba(255, 185, 62, 1) 0%, rgba(255, 91, 72, 1) 100%, rgba(255, 74, 74, 1) 100%);
		background: -moz-linear-gradient(-45deg, rgba(255, 185, 62, 1) 0%, rgba(255, 91, 72, 1) 100%, rgba(255, 74, 74, 1) 100%);
		background: -webkit-linear-gradient(-45deg, rgba(255, 185, 62, 1) 0%, rgba(255, 91, 72, 1) 100%, rgba(255, 74, 74, 1) 100%);
		background: -ms-linear-gradient(-45deg, rgba(255, 185, 62, 1) 0%, rgba(255, 91, 72, 1) 100%, rgba(255, 74, 74, 1) 100%);
		border-radius: 0px 4px 4px 0px;
		color: white;
		cursor: pointer;
		outline: none;
	}

	.ThModel1-m7 {
		width: 100%;
		text-align: center;
		font-size: 14px;
		margin-top: 10px;
	}

	.ThModel1-m7 a {
		color: #ff7a44;
	}
</style>



// WEBPACK FOOTER //
// src/config/vue/login.vue